import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
// import logo from '../assets/fkl1.png';
import logo from '../assets/fkl1.webp';
import './components.css';

const Menu = () => {
  const location = useLocation();
  const [activeMainLink, setActiveMainLink] = useState(null);

  const isActive = (pathname) => {
    return location.pathname === pathname;
  };

  const handleMainLinkClick = (linkName) => {
    setActiveMainLink(activeMainLink === linkName ? null : linkName);
    console.log(linkName)
  };

  return (
    <div className="menuContainer">
      <div className="menuBox">
        <div >
          <a href="/" className="logoContainer">
            <img src={logo} alt="Future Kenya logo" className="menuLogo" />
          </a>
        </div>
        <ul className='menuList'>
          <li className='ListLink'>
            {/* <Link to="/" className={isActive('/') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('')}>
              Home
            </Link> */}
            <a href="/" className={isActive('/') ? 'activeLink' : ''} onClick={(e) => handleMainLinkClick(e, '')}>
              Home
            </a>
          </li>

          <li className='ListLink'>
            <a href="/Acumatica" className={isActive('/AcumaticaErp') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('AcumaticaErp')}>
              Acumatica ERP
            </a>
          </li>

          <li className='ListLink'>
            <a href="/palladium-accounting-software" className={isActive('/palladium-accounting-software') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('AcumaticaErp')}>
              Palladium ERP
            </a>
          </li>

          <li className='ListLink'>
            <a href="/hr-payroll-software" className={isActive('/hr-payroll-software') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('Payspace')}>
              Payspace, HR & Payroll
            </a>
          </li>

          <li className='ListLink'>
            <Link to="/Service" className={isActive('/Service') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('Service')}>
              Services
            </Link>
            <ul className={`sublink ${activeMainLink === 'Service' ? '' : 'visible'}`}>
              <li className='sublinkList'>
                <a href="/erp-consulting">Consulting</a>
              </li>
              <li className='sublinkList'>
                <a href="/Training">Training</a>
              </li>
              <li className='sublinkList'>
                <a href="/Support">Support</a>
              </li>
            </ul>
          </li>

          <li className='ListLink'>
            <a href="/Career" className={isActive('/Career') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('Career')}>
              Work at Future Kenya
            </a>
            {/* <ul className={`sublink ${activeMainLink === 'Career' ? '' : 'visible'}`}>
              <li className='sublinkList'>
                <Link to="/Career">Jobs</Link>
              </li>
              <li className='sublinkList'>
                <Link to="/Apply">Apply Now</Link>
              </li>
            </ul> */}
          </li>

          <li className='ListLink'>
            <a href="/Contact" className={isActive('/Contact') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('Contact')}>
              Contact Us
            </a>
          </li>

          <li className='ListLink' style={{fontWeight: 'bold'}}>
            <a href="/Referral" className={isActive('/Contact') ? 'activeLink' : ''} onClick={() => handleMainLinkClick('Referral')}>
              Referral Progam
            </a>
          </li>

          <li className='ListLink' style={{fontWeight: 'bold'}}>
            <a
              href="https://acumatica.futurekenya.com/SelfServicePortal"
              target="_blank"
              rel="noopener noreferrer"
            >
              Self Service Portal
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
